import { render, staticRenderFns } from "./AttachmentPdfCard.vue?vue&type=template&id=1acc1fd4&scoped=true&"
import script from "./AttachmentPdfCard.vue?vue&type=script&lang=js&"
export * from "./AttachmentPdfCard.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentPdfCard.vue?vue&type=style&index=0&id=1acc1fd4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acc1fd4",
  null
  
)

export default component.exports